import { useMeContext } from 'modules/me';

export const useAvatar = (): { avatar: string } => {
  const me = useMeContext();
  //TODO read from avatar property once avatar is stiched into me query
  // which will return actual image or image with first name last name
  const firstNameInitial = me?.firstName?.trim()[0];
  const lastNameInitial = me?.lastName?.trim()[0];

  return {
    avatar:
      firstNameInitial && lastNameInitial
        ? `${firstNameInitial}${lastNameInitial}`
        : ''
  };
};
